import createSwiperInstance from './createSwiperInstance';

export default function initHeroSection() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll<HTMLElement>('.homepage-hero-swiper').forEach((heroCarousel, index) => {
        if (heroCarousel.classList.contains('swiper-initialized')) return;
        const hasMultipleSlides = heroCarousel.querySelectorAll('.swiper-slide').length > 1;
        createSwiperInstance(
            heroCarousel,
            {
                slidesPerView: 1,
                allowTouchMove: false,
                simulateTouch: false,
                speed: prefersReducedMotion ? 0 : 700,
                loop: hasMultipleSlides,
                autoplay: prefersReducedMotion || !hasMultipleSlides
                    ? false
                    : {
                          delay: 6000,
                          disableOnInteraction: false,
                          pauseOnMouseEnter: true,
                      },
                keyboard: { enabled: true },
                pagination: {
                    el: heroCarousel.querySelector<HTMLElement>('.homepage-hero-swiper__pagination'),
                    clickable: true,
                },
                navigation: {
                    prevEl: heroCarousel.querySelector<HTMLElement>('.homepage-hero-swiper__nav--previous'),
                    nextEl: heroCarousel.querySelector<HTMLElement>('.homepage-hero-swiper__nav--next'),
                },
            },
            `heroSection${index}`
        );
    });
}
